import gql from 'graphql-tag'

export default gql`mutation phxAutoInjectShifts($start_date_inclusive: AWSDate!, $end_date_inclusive: AWSDate!, $pod_id: String!, $template_id: String!, $filter_list: [String]!) {
	phxAutoInjectShifts(start_date_inclusive: $start_date_inclusive, end_date_inclusive: $end_date_inclusive, pod_id: $pod_id, template_id: $template_id, filter_list: $filter_list) {
		status
  }
}`
